import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const NavigationGuardContext = createContext(null);

export const NavigationGuardProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => {});
  const [onCancel, setOnCancel] = useState(() => {});

  const showDialog = (onYes, onNo) => {
    setIsOpen(true);
    setOnConfirm(() => () => {
      setIsOpen(false);
      onYes();
    });
    setOnCancel(() => () => {
      setIsOpen(false);
      onNo?.();
    });
  };

  return (
    <NavigationGuardContext.Provider value={{ showDialog }}>
      {children}
      <Dialog
        open={isOpen}
        onClose={onCancel}
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
            minWidth: 400,
            boxShadow: 10,
            fontFamily: `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1.25rem",
            mb: 1,
            fontFamily: `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
          }}
        >
          Unsaved Changes
        </DialogTitle>

        <DialogContent
          sx={{
            fontSize: "1rem",
            color: "text.secondary",
            mb: 2,
            fontFamily: `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
          }}
        >
          You have unsaved changes. Are you sure you want to leave?
        </DialogContent>

        <DialogActions
          sx={{
            justifyContent: "flex-end",
            gap: 1,
            fontFamily: `"Segoe UI", Tahoma, Geneva, Verdana, sans-serif`,
          }}
        >
          <Button
            onClick={onCancel}
            variant="outlined"
            color="primary"
            sx={{ textTransform: "none", borderRadius: 1 }}
          >
            Cancel
          </Button>
          <button
            onClick={onConfirm}
            style={{width:"80px"}}
            variant="contained"
            color="error"
            className="create-btn"
          >
            Leave
          </button>
        </DialogActions>
      </Dialog>
    </NavigationGuardContext.Provider>
  );
};

export const useNavigationGuard = () => {
  return useContext(NavigationGuardContext);
};
